















import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class Indexed extends Vue {
    @Prop() indexed!: boolean
    @Prop() notIndexedLabel?: boolean
}
